// Libs
import React from 'react';
import { createRoot } from 'react-dom/client';
import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import { Provider } from 'react-redux';
// Components, Layouts, Pages
import App from '~/App';
import { GlobalStyles } from './components/common';
// Others
import store from '~/utils/redux/store';
import { LoadingProvider, WebSocketProvider } from './context';
import reportWebVitals from './reportWebVitals';
import './thirdParties/i18n';
// Styles, images, icons
import { customTheme } from '~/themes/themeMui';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={customTheme}>
          <GlobalStyles>
            <WebSocketProvider>
              <LoadingProvider>
                <App />
              </LoadingProvider>
            </WebSocketProvider>
          </GlobalStyles>
        </ThemeProvider>
      </StyledEngineProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
